module.exports = __webpack_public_path__ + "media/images/banner9 (1)-b69a27ab366017a9721c4995b31a90c5.jpg";